export default "__VITE_ASSET__3c78e363__"